import { Filter } from '~commonInfra/utils/Filter';

import { ILeafFilterClause } from '../../spacesPlatform/models/IFilterClause';
import { NamedItemKeys } from '../../spacesPlatform/models/resourceParts';
import { IListFetcher } from '../fetchers/IListFetcher';
import { FieldValuesQuery } from './FieldValuesQuery';
import { IResourceQuery, ResourceQuery } from './ResourceQuery';

export interface IListResource<T> {
  all(): IResourceQuery<T>;
}

export interface IDetailResource<T> {
  getById(id: string): Promise<T>;
}

export interface IActionResource<T> {
  actions(id: string): Promise<T>;
}

export interface IFieldValuesResource {
  valuesForField(field: string): FieldValuesQuery;
}

export type IListAndFieldValuesResource<T> = IListResource<T> & Partial<IFieldValuesResource>;

/**
 * @deprecated Implement the interfaces IListResource<T> or IDetailResource instead. See `Views.ts` for an example
 */
export class Resource<T> implements IListResource<T>, IDetailResource<T> {

  private fetcher: IListFetcher<T>;
  private allQuery: ResourceQuery<T>;

  constructor(fetcher: IListFetcher<T>) {
    this.fetcher = fetcher;
    this.allQuery = new ResourceQuery(this.fetcher);
  }

  public all(): ResourceQuery<T> {
    return this.allQuery;
  }

  public getById(id: string, additionalFilterClauses?: ILeafFilterClause[], extraParams?: any): Promise<T> {
    let query = this.all();
    if(additionalFilterClauses) query = query.withFilters(additionalFilterClauses);
    if (extraParams) query = query.withExtraParams(extraParams);
    return query.addFilter(Filter.stringFieldEq(NamedItemKeys.id, id))
           .getFirst();
  }

}
